import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Section } from '../../../shared/public-api';

@Component({
  selector: 'admin-add-section',
  templateUrl: './add-section.component.html',
  styleUrls: ['./add-section.component.scss'],
  imports: [CommonModule],
})
export class AddSectionComponent implements OnInit {
  selections: { [key: string]: boolean } = {
    selectSection: true,
    selectTitle: false,
  };

  @Output() createSection: EventEmitter<Section<any>> = new EventEmitter<Section<any>>();

  constructor() {}

  ngOnInit(): void {}

  addSection(componentName: string): void {
    const section = new Section();
    section.componentName = componentName;
    this.createSection.next(section);
    this.displaySection('selectSection');
  }

  displaySection(sectionName: string): void {
    Object.keys(this.selections).forEach((key) => {
      if (key === sectionName) {
        this.selections[key] = true;
      } else {
        this.selections[key] = false;
      }
    });
  }
}
